module.exports = __webpack_public_path__ + "images/privacy_policy.pdf?v=af4449dabadc24c1d8a29041364b5929";